import { Box, Button } from "@mui/material";
import { grey } from "@mui/material/colors";

import React from "react";

import { SearchBoxConnectorParams } from "instantsearch.js/es/connectors/search-box/connectSearchBox";
import { useSearchBox } from "react-instantsearch-hooks-web";

function PopularQueries({
    queries,
    ...props
}: { queries?: string[] } & SearchBoxConnectorParams) {
    const { refine } = useSearchBox(props);

    return (
        <Box mt={1} sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            {queries?.map((query: string) => (
                <Button
                    key={query}
                    onClick={() => refine(query)}
                    variant="outlined"
                    sx={{ ml: 0, mb: 1, mr: 1, borderColor: grey[800], color: grey[800] }}
                >
                    “{query}”
                </Button>
            ))}
        </Box>
    );
}

export default PopularQueries;
